import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const LangSwitch = () => {
  const { i18n } = useTranslation();
  return (
    <div className="lang-switch">
      <ToggleButtonGroup
        value={i18n.language}
        exclusive
        onChange={(_, lang) => {
          if (lang) {
            i18n.changeLanguage(lang);
            localStorage.setItem('i18n_language', lang);
          }
        }}
        size="small"
        className="lang-switch__toggle"
      >
        <ToggleButton value="fr">FR</ToggleButton>
        <ToggleButton value="ro">RO</ToggleButton>
        <ToggleButton value="en">EN</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default LangSwitch;
